import React from 'react';
import { makeStyles } from '@material-ui/core';

import { Grid, units } from '@ha/dsl';
import { useConversionTracker } from 'ha/modules/Analytics/hooks';
import { useFeatureFlags } from 'ha/modules/FeatureFlags';

import SearchResultsBottom from './SearchResultsBottom';
import SearchResultsEmpty from './SearchResultsEmpty';
import { useSearchResultsContentCard } from './SearchResultsContentCard';
import SearchResultsList from './SearchResultsList';
import SearchResultsListNext from './SearchResultsListNext';
import { SearchResultsNotification } from './SearchResultsNotification';
import SearchResultsNotificationNext from './SearchResultsNotificationNext';
import SearchDatesFilterNotification from './SearchDatesFilterNotification';
import SearchResultsUseMapFilterNotification from './SearchResultsUseMapFilterNotification';
import { SearchListing } from '../types';

interface Props {
  items: SearchListing[];
  cityCanonical?: string;
  countryCanonical?: string;
  countryCode?: string;
  shouldShowCitiesNearby: boolean;
  cityLocalizedName?: string;
  countryLocalizedName?: string;
}

const useStyles = makeStyles(theme => ({
  scrollWrapper: {
    flexGrow: 1,
    padding: units.yx(0, 0.75),
    [theme.breakpoints.up('md')]: {
      padding: '0',
    },
  },
}));

export const SearchResults: React.FC<Props> = ({
  items,
  shouldShowCitiesNearby,
  cityCanonical,
  countryCanonical,
  countryCode,
  cityLocalizedName,
  countryLocalizedName = '',
}) => {
  const classes = useStyles();
  const { trackSearchView } = useConversionTracker();
  const { searchContractTypeSuggestion } = useFeatureFlags();
  const { isContentCardAvailable } = useSearchResultsContentCard(items.length);

  React.useEffect(() => {
    trackSearchView(items, countryCode || '');
  }, [trackSearchView, items, countryCode]);

  return (
    <div className={classes.scrollWrapper}>
      {items.length > 0 ? (
        <React.Fragment>
          {searchContractTypeSuggestion === 'on' ? (
            <SearchResultsNotificationNext />
          ) : (
            <SearchResultsNotification />
          )}
          <SearchDatesFilterNotification />
          <Grid container spacing={3}>
            {isContentCardAvailable ? (
              <SearchResultsListNext items={items} />
            ) : (
              <SearchResultsList items={items} />
            )}
          </Grid>
        </React.Fragment>
      ) : (
        <SearchResultsEmpty />
      )}
      <SearchResultsUseMapFilterNotification />
      <SearchResultsBottom
        cityCanonical={cityCanonical}
        countryCanonical={countryCanonical}
        countryCode={countryCode}
        cityLocalizedName={cityLocalizedName}
        countryLocalizedName={countryLocalizedName}
        shouldShowCitiesNearby={shouldShowCitiesNearby}
      />
    </div>
  );
};

export default SearchResults;
